export const origins = {
  lot: 'Lote',
  cashRegister: 'Particular (caixa)',
  medicalReport: 'Laudos',
};

export const shortNames = {
  lot: 'Lote',
  cashRegister: 'Particular',
  medicalReport: 'Laudos',
};

export const descriptions = {
  lot: 'Contas a pagar criadas ao fechar o lote',
  cashRegister: 'Itens recebidos no caixa ainda sem conta a pagar',
  medicalReport: 'Laudos assinados ainda sem conta a pagar',
};

export const icons = {
  lot: 'layer-group',
  cashRegister: 'cash-register',
  medicalReport: 'file-signature',
};

export const emptyTexts = {
  lot: 'Nenhum lote fechado nesta competência.',
  cashRegister: 'Nenhum atendimento particular pendente no período.',
  medicalReport: 'Nenhum laudo assinado pendente no período.',
};

export function getName(value) {
  return origins[value];
}
